'use client';

import { Button, CircularProgress } from '@mui/material';
import { alpha } from '@mui/material/styles';

import { useT } from '@/hooks';

interface AuthButtonsProps {
  onLoginClick: () => void;
  loading?: boolean;
}

export const AuthButtons = ({ onLoginClick, loading = false }: AuthButtonsProps) => {
  const { t } = useT();
  return (
    <Button
      variant="contained"
      onClick={onLoginClick}
      disabled={loading}
      sx={{
        display: 'inline-flex',
        borderRadius: '8px',
        textTransform: 'none',
        fontWeight: 600,
        px: { xs: 2, sm: 2.5 },
        py: { xs: 0.625, sm: 0.75 },
        fontSize: { xs: '0.875rem', sm: '0.9375rem' },
        bgcolor: 'primary.main',
        color: 'primary.contrastText',
        border: 'none',
        boxShadow: 'none',
        minHeight: { xs: '36px', sm: '40px' },
        '&:hover': {
          bgcolor: 'primary.dark',
          boxShadow: 'none',
        },
        '&.Mui-disabled': {
          bgcolor: 'primary.main',
          opacity: 0.7,
        },
      }}
    >
      {loading ? <CircularProgress size={20} color="inherit" sx={{ mr: 1 }} /> : null}
      {!loading && t('auth.logIn', { defaultValue: 'Log In' })}
    </Button>
  );
};
